export enum LoadChangedAction {
    TenderAccepted = 'TenderAccepted',
    TenderCancelled = 'TenderCancelled',
    Cancelled = 'Cancelled',
    Expired = 'Expired',
    Confirmed = 'Confirmed',
    ConfirmationPool = 'ConfirmationPool',
    Prioritized = 'Prioritized',
    Suspended = 'Suspended',
    StatusTmsUpdated = 'StatusTmsUpdated',
    WaitingAcceptance = 'WaitingAcceptance',
    WaitingConfirmation = 'WaitingConfirmation',
    Ready = 'Ready',
    FirstRound = 'FirstRound',
    ReOffer = 'ReOffer',
    Download = 'Download',
    Unsuspended = 'Unsuspended',
    SentToPool = 'SentToPool',
    VisibilityChanged = 'VisibilityChanged',
    VisibilityChangedHistory = 'VisibilityChangedHistory',
    ConfirmationTermsAccepted = 'ConfirmationTermsAccepted',
}

export const LoadActionMap: Record<string, string> = {
    [LoadChangedAction.TenderAccepted]: 'LoadHistory.Events.TenderAccepted',
    [LoadChangedAction.TenderCancelled]: 'LoadHistory.Events.TenderCancelled',
    [LoadChangedAction.Cancelled]: 'LoadHistory.Events.Cancelled',
    [LoadChangedAction.Expired]: 'LoadHistory.Events.Expired',
    [LoadChangedAction.Confirmed]: 'LoadHistory.Events.Confirmed',
    [LoadChangedAction.ConfirmationPool]: 'LoadHistory.Events.ConfirmationPool',
    [LoadChangedAction.Prioritized]: 'LoadHistory.Events.Prioritized',
    [LoadChangedAction.Suspended]: 'LoadHistory.Events.Suspended',
    [LoadChangedAction.StatusTmsUpdated]: 'LoadHistory.Events.StatusTmsUpdated',
    [LoadChangedAction.WaitingAcceptance]:
        'LoadHistory.Events.WaitingAcceptance',
    [LoadChangedAction.WaitingConfirmation]:
        'LoadHistory.Events.WaitingConfirmation',
    [LoadChangedAction.Ready]: 'LoadHistory.Events.Planned',
    [LoadChangedAction.FirstRound]: 'LoadHistory.Events.FirstRound',
    [LoadChangedAction.ReOffer]: 'LoadHistory.Events.ReOffer',
    [LoadChangedAction.Download]: 'LoadHistory.Events.Download',
    [LoadChangedAction.Unsuspended]: 'LoadHistory.Events.Unsuspended',
    [LoadChangedAction.SentToPool]: 'LoadHistory.Events.SentToPool',
    [LoadChangedAction.VisibilityChanged]:
        'LoadHistory.Events.VisibilityChanged',
    [LoadChangedAction.VisibilityChangedHistory]:
        'LoadHistory.Events.VisibilityChangedHistory',
    [LoadChangedAction.ConfirmationTermsAccepted]:
        'LoadHistory.Events.ConfirmationTermsAccepted',
};

export const LoadHistoryReasonsMap: Record<string, string> = {
    'Load reference number updated in TMS':
        'LoadHistory.Reasons.LoadReferenceNumberUpdatedInTms',
    'Load cannot be offered due its expired collection date':
        'LoadHistory.Reasons.LoadCannotBeOfferedDueItsExpiredCollectionDate',
    'Load confirmed successfully in TMS':
        'LoadHistory.Reasons.LoadConfirmedSuccessfullyInTms',
    'Load expired after details download':
        'LoadHistory.Reasons.LoadExpiredAfterDetailsDownload',
    'Load interrupted by plan event':
        'LoadHistory.Reasons.LoadInterruptedByPlanEvent',
    'Load suspended event received':
        'LoadHistory.Reasons.LoadSuspendedEventReceived',
    'Load tender accepted event received':
        'LoadHistory.Reasons.LoadTenderAcceptedEventReceived',
    'Load tender accepted SPOT-Dedicated Fleet event received':
        'LoadHistory.Reasons.LoadTenderAcceptedSpotDedicatedFleetEventReceived',
    'Load cancel event received': 'LoadHistory.Reasons.LoadCancelEventReceived',
    'Load tender cancelled event received':
        'LoadHistory.Reasons.LoadTenderCancelledEventReceived',
    Cancelado: 'LoadHistory.Reasons.Cancelado',
    'Cancelado pelo usuário TMS': 'LoadHistory.Reasons.CanceladoPeloUsuarioTms',
    'Load re-offer': 'LoadHistory.Reasons.LoadReofer',
    'Load download successfully': 'LoadHistory.Reasons.DownloadSuccessfully',
};

export const LoadHistoryStatusTmsMap: Record<string, string> = {
    Planned: 'LoadHistory.StatusTms.Planned',
    Cancelada: 'LoadHistory.StatusTms.Cancelada',
    Tendering: 'LoadHistory.StatusTms.Tendering',
    Confirmada: 'LoadHistory.StatusTms.Confirmada',
    NotAccepted: 'LoadHistory.StatusTms.NotAccepted',
    TenderAccepted: 'LoadHistory.StatusTms.TenderAccepted',
};
